import React, { Component } from 'react'
import { t } from 'i18next'
import './index.css'

export default class Footer extends Component {
  render() {
    return (
      <footer>
        <p>Copyright Bizon Prefab 2017 – {new Date().getFullYear()}.</p>
        <small>{t('footer.site_by')} <a href="http://bobwassermann.me" target="_blank" rel="noopener noreferrer">Bob Wassermann</a></small>
      </footer>
    )
  }
}


// WEBPACK FOOTER //
// ./src/Components/Footer/index.js